import {useCallback,useEffect,useRef} from 'react';
import apiFetch from '../../../utils/apiFetch';
import {createDefenderReactionOpportunity} from './combatSaveStateService';
import {defenderDamageModifiers} from './reactions';
export default function useDefenderReactions(campaignId,onCombatChange,combatState){
 const mounted=useRef(true),onChange=useRef(onCombatChange),combat=useRef(combatState),scope=useRef(campaignId);onChange.current=onCombatChange;combat.current=combatState;scope.current=campaignId;
 useEffect(()=>{mounted.current=true;return()=>{mounted.current=false;};},[]);
 return useCallback(async payload=>{
  if(combat.current && (combat.current.activeTurn==null||![payload.sourceCombatantId,payload.targetCombatantId].every(id=>combat.current.participants?.some(p=>String(p.characterId||p.enemyId)===String(id)))))return {incomingDamageModifiers:[]};
  const created=await createDefenderReactionOpportunity(campaignId,payload);
  if(!mounted.current||scope.current!==campaignId)throw new Error('The defender decision was interrupted.');
  if(created.combat)onChange.current?.(created.combat);
  if(created.status==='no-candidates')return {incomingDamageModifiers:[]};
  if(created.status==='resolved')return {opportunity:created.opportunity,incomingDamageModifiers:[]};
  let opportunity=created.opportunity;
  while(opportunity?.status==='pending'){
   await new Promise(resolve=>setTimeout(resolve,750));
   if(!mounted.current||scope.current!==campaignId)throw new Error('The defender decision was interrupted.');
   const r=await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat`,{cache:'no-store'});if(!r.ok)throw new Error('The defender decision could not be refreshed.');
   const combat=await r.json();if(!mounted.current||scope.current!==campaignId)throw new Error('The defender decision was interrupted.');onChange.current?.(combat);
   opportunity=combat.reactionOpportunities?.find(o=>o.opportunityId===created.opportunity?.opportunityId);
   if(!opportunity)throw new Error('The defender decision is no longer available.');
  }
  return {opportunity,incomingDamageModifiers:defenderDamageModifiers(opportunity)};
 },[campaignId]);
}
